<ul class="checkmark-list">
  <li *ngFor="let item of items" class="checkmark-wrapper">
    <i2g-checkmark class="checkmark"></i2g-checkmark>

    <ng-container [ngSwitch]="htmlContent">
      <ng-container *ngSwitchCase="true">
        <span [innerHTML]="item.value | safe: 'html'"></span>
      </ng-container>

      <ng-container *ngSwitchDefault>
        {{ item.value }}
      </ng-container>
    </ng-container>

    <i2g-icon *ngIf="item.icon" class="icon" [icon]="item.icon"> </i2g-icon>
  </li>
</ul>
